import { Link } from 'react-router-dom';
import ShieldIcon from '../../assets/icon-shield.svg?react';
import './style.scss';
import useElysiaStore from '@/app/elysia-store';

const SystemProtectionMessage = () => {
  const isChatActive = useElysiaStore((state) => state.isChatActive);
  const starterPrompts = useElysiaStore((state) => state.starterPrompts);
  return (
    <div
      className={`sys-protection-wrapper ${!isChatActive && starterPrompts?.filter((prompts) => prompts !== '').length <= 1 ? 'sys-protection-alignment' : ''}`}
    >
      <div className="d-flex justify-content-center align-items-center">
        <ShieldIcon />
        <span className="sys-msg-card-title">
          {' '}
          Your personal and company data are protected in this chat{' '}
        </span>
      </div>
      <div className="sys-msg-disclaimer d-flex gap-1">
        <p>Elysia responses may be inaccurate. Know more about how your data is processed</p>
        <Link
          to="https://portal.informa.com/sites/compliance/document/303301/Elysia-Notice-and-Acceptable-Use-Policy"
          target="_blank"
          className="custom-link"
        >
          here
        </Link>
      </div>
    </div>
  );
};

export default SystemProtectionMessage;
